;(function() {
  'use strict';

  var toggle = {
    init: function (options) {
      var config = $.extend({
        class: '.js-toggle',
        header: '.js-toggle__header',
        body: '.js-toggle__body',
        close: 'is-close',
        dataHeight: 'height'
      }, options);

      if (!$(config.class).length) {
        return false;
      }

      $(config.class).each(function () {
        var _toggle = $(this),
          _header = _toggle.find(config.header),
          _body = _toggle.find(config.body);

        // 初期表示
        _body.data(config.dataHeight, _body.outerHeight(true));
        if (_toggle.hasClass(config.close)) {
          // close
          _header.addClass(config.close);
          _body.addClass(config.close)
               .css('maxHeight', 0);
        }

        // イベントハンドラ
        _header.on('click', function () {
          $(this).addClass('js-toggle-target')

          // クリックした対象のみを開いた状態にする場合はjs-toggleとセットでjs-toggle-allクラスを付与する
          $('.js-toggle-all').each(function () {
            var _close = $(this),
              _closeHeader = _close.find(config.header),
              _closeBody = _close.find(config.body);

            if (!_closeHeader.hasClass('js-toggle-target')) {
                _closeHeader.addClass(config.close);
                _closeBody.addClass(config.close)
                    .css('maxHeight', 0);
            }
          })

          if (_header.hasClass(config.close)) {
            // close -> open
            _header.removeClass(config.close);
            _body.removeClass(config.close)
                 .css('maxHeight', 'none');
          } else {
            // open -> close
            _header.addClass(config.close);
            _body.addClass(config.close)
                 .css('maxHeight', 0);
          }

        $(this).removeClass('js-toggle-target')
        });
      });
    }
  };


  /**
   * DOM content loaded
   */
 $(window).on('load', function () {
   $(function () {
     // 要素の高さが変わる可能性があるため、load イベントで実行する
     toggle.init();
   });
 });
}.call(this));
